@if (storeMap) {
  <div class="issueMapThumb">
    <img class="mapImage" src="{{storeMap.image['thumb']}}" alt="map image"/>
    <img class="overlayImage" src="{{overlayImageUrl}}" alt=""/>
  </div>
}
